module.exports = __webpack_public_path__ + "img/manage-full-icon.c1a7b6c4.svg";